const features = [
  {
    icon: 'ri-map-2-line',
    title: '직업전공 매트릭스',
    description: '커리어넷 기반 700개+ 직업과 전공 연결 데이터베이스',
    stat: '700+',
    statLabel: '직업 데이터',
  },
  {
    icon: 'ri-book-marked-line',
    title: '2022 개정 교육과정',
    description: '서울시교육청 선택과목 안내서 완전 반영',
    stat: '138개',
    statLabel: '선택 과목',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: '학종 5단계 공식',
    description: '현직 컨설턴트의 생기부 작성 공식 완전 반영',
    stat: '5단계',
    statLabel: '생기부 공식',
  },
];

const trackStats = [
  { track: '인문계열', icon: 'ri-book-open-line', color: 'bg-primary-100 text-primary-700', count: '7개 전공' },
  { track: '사회계열', icon: 'ri-global-line', color: 'bg-accent-100 text-accent-700', count: '9개 전공' },
  { track: '자연계열', icon: 'ri-flask-line', color: 'bg-secondary-100 text-secondary-700', count: '8개 전공' },
  { track: '공학계열', icon: 'ri-settings-3-line', color: 'bg-primary-100 text-primary-700', count: '9개 전공' },
  { track: '예체능계열', icon: 'ri-palette-line', color: 'bg-accent-100 text-accent-700', count: '5개 전공' },
  { track: '교육계열', icon: 'ri-graduation-cap-line', color: 'bg-secondary-100 text-secondary-700', count: '4개 전공' },
];

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Features */}
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            탄탄한 데이터 기반 플랫폼
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            공신력 있는 자료를 기반으로 만들어졌습니다
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-14">
          {features.map((f) => (
            <div key={f.title} className="bg-background-50 border border-background-200 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                  <i className={`${f.icon} text-primary-600`}></i>
                </div>
                <div>
                  <div className="font-bold text-foreground-950 text-lg leading-none">{f.stat}</div>
                  <div className="text-xs text-foreground-500">{f.statLabel}</div>
                </div>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-1">{f.title}</h3>
              <p className="text-foreground-600 text-xs leading-relaxed">{f.description}</p>
            </div>
          ))}
        </div>

        {/* Track Coverage */}
        <div className="text-center mb-6">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            6개 계열 모두 커버
          </h3>
          <p className="text-foreground-600 text-sm">어떤 계열을 희망하든 맞춤 안내를 받을 수 있습니다</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {trackStats.map((t) => (
            <div key={t.track} className={`${t.color} rounded-xl p-4 text-center`}>
              <div className="flex items-center justify-center mb-2">
                <i className={`${t.icon} text-2xl`}></i>
              </div>
              <div className="font-semibold text-sm">{t.track}</div>
              <div className="text-xs opacity-75 mt-0.5">{t.count}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}